import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import { Link, useNavigate } from "react-router-dom";
import { useLogout } from "../../../hooks/useLogout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PaymentsIcon from "@mui/icons-material/Payments";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AddCardIcon from "@mui/icons-material/AddCard";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import StarsIcon from "@mui/icons-material/Stars";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ArticleIcon from "@mui/icons-material/Article";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "400px",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

export default function ProfileDropdown({ user }) {
  const navigate = useNavigate();
  const { logout } = useLogout();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //  const handleLogoutModal = () => {
  //     document.getElementById("my_logout_modal").showModal();
  //   };

  //   const handleLogoout = () => {
  //     logout();
  //     navigate("/");
  //     document.getElementById("my_logout_modal").close();
  // };

  const [showLogoutModal, setShowLogoutModal] = React.useState(false);
  const handleLogoutModal = () => {
    handleClose(); // Close the dropdown menu
    setShowLogoutModal(true);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
    setShowLogoutModal(false);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Tooltip title="My Account">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar
              sx={{
                width: { xs: 26, lg: "2vw" },
                height: { xs: 26, lg: "2vw" },
                fontSize: { xs: 12, lg: "0.8vw" },
                backgroundColor: user ? "#ca0000" : "",
              }}
            >
              {user ? user.username.charAt(0) : <AccountCircleIcon />}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        disableScrollLock
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflowY: "auto",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem>
          {user?.profilePicture ? (
            <Avatar src={user?.profilePicture || ""} />
          ) : (
            <Avatar sx={{ width: 32, height: 32 }}>
              {user?.username?.charAt(0) || <AccountCircleIcon />}
            </Avatar>
          )}
          {user ? (
            <div className="flex flex-col">
              {user?.username}
              <Typography variant="body2" color="text.secondary">
                {user?.email}
              </Typography>
            </div>
          ) : (
            <Link to="/login" className="text-gray-600">
              Please login to continue
            </Link>
          )}
        </MenuItem>

        {user && <Divider />}
        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/account/profile");
            }}
          >
            <ListItemIcon>
              <AccountCircleIcon fontSize="small" />
            </ListItemIcon>
            My Account
          </MenuItem>
        )}
        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/apply-for-loan");
            }}
          >
            <ListItemIcon>
              <PaymentsIcon fontSize="small" />
            </ListItemIcon>
            Apply For Loan
          </MenuItem>
        )}

        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/fees");
            }}
          >
            <ListItemIcon>
              <ArticleIcon fontSize="small" />
            </ListItemIcon>
            Fee Overview
          </MenuItem>
        )}

        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/video-demo");
            }}
          >
            <ListItemIcon>
              <YouTubeIcon fontSize="small" />
            </ListItemIcon>
            Video Demo
          </MenuItem>
        )}

        {user && <Divider />}

        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/account/local-cars");
            }}
          >
            <ListItemIcon>
              <DirectionsCarIcon fontSize="small" />
            </ListItemIcon>
            My Vehicles
          </MenuItem>
        )}
        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/account/saved-cars");
            }}
          >
            <ListItemIcon>
              <BookmarkIcon fontSize="small" />
            </ListItemIcon>
            Saved Cars
          </MenuItem>
        )}

        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/saved-searches");
            }}
          >
            <ListItemIcon>
              <ContentPasteSearchIcon fontSize="small" />
            </ListItemIcon>
            Saved Searches
          </MenuItem>
        )}
        {user && <Divider />}

        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/account/funds");
            }}
          >
            <ListItemIcon>
              <MonetizationOnIcon fontSize="small" />
            </ListItemIcon>
            My Deposit
          </MenuItem>
        )}
        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/account/funds");
            }}
          >
            <ListItemIcon>
              <AddCardIcon fontSize="small" />
            </ListItemIcon>
            Add Deposits
          </MenuItem>
        )}

        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/get-all-invoices");
            }}
          >
            <ListItemIcon>
              <ReceiptLongIcon fontSize="small" />
            </ListItemIcon>
            Invoices
          </MenuItem>
        )}

        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/account/transactions");
            }}
          >
            <ListItemIcon>
              <AddCardIcon fontSize="small" />
            </ListItemIcon>
            Transactions
          </MenuItem>
        )}

        {user && <Divider />}
        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/account/all-bids");
            }}
          >
            <ListItemIcon>
              <LocalOfferIcon fontSize="small" />
            </ListItemIcon>
            My Bids
          </MenuItem>
        )}
        {user && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/user/account/order");
            }}
          >
            <ListItemIcon>
              <StarsIcon fontSize="small" />
            </ListItemIcon>
            Won Bids
          </MenuItem>
        )}
      {user && (
          <MenuItem sx={{ color: "#ca0000" }} onClick={handleLogoutModal}>
          <ListItemIcon>
            <Logout fontSize="small" sx={{ color: "#ca0000" }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      )}
      </Menu>
      <Modal
        open={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={showLogoutModal}>
          <Box sx={modalStyle}>
            <Typography
              id="logout-modal-title"
              variant="h6"
              component="h2"
              align="center"
              gutterBottom
              sx={{
                color: "#666",
                fontWeight: "bold",
                fontSize: "18px",
                mb: 2,
              }}
            >
              Do you want to logout your account?
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                mt: 3,
              }}
            >
              <Button
                onClick={handleLogout}
                sx={{
                  minWidth: 70,
                  py: 1,
                  border: "1px solid #22c55e",
                  color: "#22c55e",
                  "&:hover": {
                    backgroundColor: "rgba(34, 197, 94, 0.8)",
                    color: "white",
                    border: "1px solid #22c55e",
                  },
                }}
              >
                Confirm
              </Button>
              <Button
                onClick={() => setShowLogoutModal(false)}
                sx={{
                  minWidth: 70,
                  py: 1,
                  border: "1px solid #ef4444",
                  color: "#ef4444",
                  "&:hover": {
                    backgroundColor: "rgba(239, 68, 68, 0.8)",
                    color: "white",
                    border: "1px solid #ef4444",
                  },
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}
